module.exports = __webpack_public_path__ + "static/retail-content-image-retail-units-en-v2-3d5516b51c818cb1d7eaa2b4c9003dec.jpg";